import React from "react";
import cx from "classnames";
import { editorHeader } from "../_styles/header";
import { editorSection } from "../_styles/section";
import { H4 } from "@ui/Text";
import t from "../../../../../../../../i18n";
import { spacings } from "@ui/Theme";
import { css } from "@linaria/core";
import type { BlockImageModelT } from "../../../../../schema/block/image";
import { useCurrentEditorBlock } from "../../../../../hook/context/gui";
import { BlockPosition } from "../BlockPosition";
import { BlockDataTitle } from "../BlockDataTitle";
import { BlockFile } from "../BlockFile";

export function ImageEditor({ projectId }: { projectId: string }) {
  const block = useCurrentEditorBlock<BlockImageModelT>("IMAGE");

  if (!block) return null;

  return (
    <div>
      <header className={cx(editorHeader, editorSection)}>
        <H4>
          {t("project.dashboard.editor.gui.title", t("project.dashboard.block.kind", "IMAGE"))}
        </H4>
      </header>
      <section className={editorSection}>
        <BlockPosition block={block} />
      </section>
      <section className={editorSection}>
        <BlockDataTitle key={block.id} block={block} />
      </section>
      <section className={cx(editorSection, blockFileSection)}>
        <BlockFile projectId={projectId} block={block} deletable />
      </section>
    </div>
  );
}

const blockFileSection = css`
  margin-top: ${spacings.m};
`;
